import React, { useState } from "react";
import CloneCategoryContext from "./CloneCategoryContext";

const CloneCategoryState = (props) => {
  const [formValue, setFormValue] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    webIds: [],
    allItem: [],
  });
  const [progress, setProgress] = useState(0);
  const [sortOrder, setSortOrder] = useState(""); //SORTING -->
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("createdAt"); //SORTING -->
  const [pageLimit, setPageLimit] = useState("");
  const [record, setRecord] = useState(0);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [addModel, setAddModel] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [id, setId] = useState("");
  return (
    <CloneCategoryContext.Provider
      value={{
        formValue,
        setFormValue,
        pageSize,
        setPageSize,
        sortOrder,
        setSortOrder,
        page,
        setPage,
        sortBy,
        setSortBy,
        pageLimit,
        setPageLimit,
        record,
        setRecord,
        isSwitchOn,
        setIsSwitchOn,
        addModel,
        setAddModel,
        formData,
        setFormData,
        isEdit,
        setIsEdit,
        id,
        setId,
        progress,
        setProgress,
      }}
    >
      {props.children}
    </CloneCategoryContext.Provider>
  );
};

export default CloneCategoryState;
